import { IntlKey } from 'locales';
import React from 'react';

import './design-system.scss';
import { Collapse } from 'react-bootstrap';
import { useIntl } from 'react-intl';

type Props = {
  title?: IntlKey;
  count: number;
  isCollapsed: boolean;
  toggleCollapse: () => void;
  children: React.ReactNode;
};

export function DocumentList({
  title = 'regulatoryDocuments.title',
  children,
  isCollapsed,
  toggleCollapse,
  count,
}: Props) {
  const { formatMessage } = useIntl();

  const hasDocuments = count > 0;
  return (
    <div className="trade-docs border border-opacity-70 d-grid">
      <button
        className="btn btn-collapse btn-xl collapse-fill collapse-icon-end ps-3"
        type="button"
        aria-expanded={!isCollapsed}
        onClick={toggleCollapse}
      >
        <label className="d-flex align-items-center gap-2">
          <span>{formatMessage({ id: title, defaultMessage: 'Documents' })}</span>
          {hasDocuments && (
            <span className="badge badge-discreet-primary badge-sm rounded-pill">
              <span>{count}</span>
            </span>
          )}
        </label>
      </button>
      <Collapse in={!isCollapsed}>
        <div>
          <div className="card card-body pt-0 pb-2 px-2">
            <ul className="list-group list-group-flush">{children}</ul>
          </div>
        </div>
      </Collapse>
    </div>
  );
}
